module.exports = __webpack_public_path__ + "5f52fda29b4f846b58725d0e6d1ac700.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/news/girl-dots.jpg
 ** module id = 460
 ** module chunks = 0
 **/